/**
 * Curated list of community-management platforms shown in the wizard's
 * "How do you run your community today?" diagnostic. Persona/region
 * agnostic — keep the order ranked by likelihood of recognition rather
 * than alphabetic.
 *
 * `key` is what gets persisted to draft.policies.currentPlatform; `name`
 * + `description` drive the dropdown row UI. The `'other'` option pairs
 * with a freeform draft.policies.currentPlatformOther string.
 *
 * `placeholder` is consumed by the platform-handle input below the
 * dropdown and adapts to the selected option. Custom / Other / no
 * selection fall back to a generic "Your community URL".
 */
export const MANAGEMENT_PLATFORMS = [
  {
    key: 'spond',
    name: 'Spond',
    description: 'Team & community management',
    placeholder: 'https://group.spond.com/...',
  },
  {
    key: 'teamsnap',
    name: 'TeamSnap',
    description: 'Team scheduling and chat',
    placeholder: 'https://go.teamsnap.com/...',
  },
  {
    key: 'heya',
    name: 'Heya',
    description: 'Community games platform',
    placeholder: 'https://heya.so/...',
  },
  {
    key: 'leagueapps',
    name: 'LeagueApps',
    description: 'Youth sports management',
    placeholder: 'https://www.leagueapps.com/...',
  },
  {
    key: 'playfinder',
    name: 'Playfinder',
    description: 'Venue booking & community',
    placeholder: 'https://www.playfinder.com/...',
  },
  {
    key: 'custom',
    name: 'Custom / in-house',
    description: 'You built your own',
    placeholder: 'Your community URL',
  },
  {
    key: 'other',
    name: 'Other',
    description: 'Something not listed',
    placeholder: 'Your community URL',
  },
]

const DEFAULT_PLATFORM_PLACEHOLDER = 'Your community URL'

export function getPlatformPlaceholder(key) {
  if (!key) return DEFAULT_PLATFORM_PLACEHOLDER
  const row = MANAGEMENT_PLATFORMS.find((p) => p.key === key)
  return row?.placeholder || DEFAULT_PLATFORM_PLACEHOLDER
}
